<!--
 * @Author: mobai
 * @Date: 2022-07-12 14:58:51
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-13 09:39:14
 * @FilePath: \qym-lishui\src\gov\views\corporateInteraction\enterprise\components\entStyle.vue
-->
<template>
  <div class="entStyle">
    <div class="edit-btn">
      <el-button type="primary" @click="edit">编辑</el-button>
    </div>
    <section class="flex">
      <div class="left-title">企业宣传视频</div>
      <div v-if="videos && videos.length" class="imgList">
        <div v-for="item in videos" :key="item.ossUrl">
          <div class="imgOrVideo" v-if="item.fileType == 3">
            <video :src="item.ossUrl" class="avatar" controls="controls">
              您的浏览器不支持视频播放
            </video>
          </div>
          <div class="imgOrVideo" v-if="item.fileType == 1">
            <el-image :src="item.ossUrl" :preview-src-list="[item.ossUrl]" />
          </div>
        </div>
      </div>
      <div class="noData" v-else>
        <img src="~@/assets/imagess/es-sfss.png" alt="" />
      </div>
    </section>
    <section class="flex">
      <div class="left-title">董事长照片</div>
      <div v-if="chairmanes && chairmanes.length" class="imgList">
        <div v-for="item in chairmanes" :key="item.ossUrl">
          <div class="imgOrVideo" v-if="item.fileType == 3">
            <video :src="item.ossUrl" class="avatar" controls="controls">
              您的浏览器不支持视频播放
            </video>
          </div>
          <div class="imgOrVideo" v-if="item.fileType == 1">
            <el-image :src="item.ossUrl" :preview-src-list="[item.ossUrl]" />
          </div>
        </div>
      </div>
      <div class="noData" v-else>
        <img src="~@/assets/imagess/es-sfss.png" alt="" />
      </div>
    </section>
    <section class="flex">
      <div class="left-title">厂房照片</div>
      <div v-if="entWorkshops && entWorkshops.length" class="imgList">
        <div v-for="item in entWorkshops" :key="item.ossUrl">
          <div class="imgOrVideo" v-if="item.fileType == 3">
            <video :src="item.ossUrl" class="avatar" controls="controls">
              您的浏览器不支持视频播放
            </video>
          </div>
          <div class="imgOrVideo" v-if="item.fileType == 1">
            <el-image :src="item.ossUrl" :preview-src-list="[item.ossUrl]" />
          </div>
        </div>
      </div>
      <div class="noData" v-else>
        <img src="~@/assets/imagess/es-sfss.png" alt="" />
      </div>
    </section>
    <section class="flex">
      <div class="left-title">产品照片</div>
      <div v-if="products && products.length" class="imgList">
        <div v-for="item in products" :key="item.ossUrl">
          <div class="imgOrVideo" v-if="item.fileType == 3">
            <video :src="item.ossUrl" class="avatar" controls="controls">
              您的浏览器不支持视频播放
            </video>
          </div>
          <div class="imgOrVideo" v-if="item.fileType == 1">
            <el-image :src="item.ossUrl" :preview-src-list="[item.ossUrl]" />
          </div>
        </div>
      </div>
      <div class="noData" v-else>
        <img src="~@/assets/imagess/es-sfss.png" alt="" />
      </div>
    </section>
    <section class="flex">
      <div class="left-title">企业荣誉</div>
      <div v-if="honorFiles && honorFiles.length" class="imgList">
        <div v-for="item in honorFiles" :key="item.ossUrl">
          <div class="imgOrVideo" v-if="item.fileType == 3">
            <video :src="item.ossUrl" class="avatar" controls="controls">
              您的浏览器不支持视频播放
            </video>
          </div>
          <div class="imgOrVideo" v-if="item.fileType == 1">
            <el-image :src="item.ossUrl" :preview-src-list="[item.ossUrl]" />
          </div>
        </div>
      </div>
      <div class="noData" v-else>
        <img src="~@/assets/imagess/es-sfss.png" alt="" />
      </div>
    </section>

    <el-dialog
      title="编辑企业风采"
      :visible.sync="dialogVisible"
      width="68%"
      @closed="handleClose"
    >
      <div>
        <el-form :model="ruleForm" ref="ruleForm">
          <el-col :span="24">
            <el-form-item>
              <div class="dialog-title">
                企业宣传视频<el-tooltip
                  class="item"
                  effect="dark"
                  :content="content"
                  placement="top-start"
                >
                  <i class="el-icon-warning-outline"></i
                ></el-tooltip>
              </div>
              <!-- action必选参数, 上传的地址 -->
              <div class="dialog-imgItem">
                <div
                  v-for="(item, index) in ruleForm.videoList"
                  :key="item.ossUrl"
                  class="dialog-imgView"
                >
                  <div v-if="item.fileType == 3">
                    <video
                      :src="item.ossUrl"
                      class="avatar"
                      controls="controls"
                    >
                      您的浏览器不支持视频播放
                    </video>
                    <i
                      class="del-img el-icon-close"
                      @click="forkImage(index, 'videoList')"
                    ></i>
                  </div>
                  <div v-if="item.fileType == 1">
                    <el-image
                      :src="item.ossUrl"
                      alt=""
                      :preview-src-list="[item.ossUrl]"
                      :z-index="zIndex"
                    />
                    <i
                      class="del-img el-icon-close"
                      @click="newforkImage(index, 'videoList')"
                    ></i>
                  </div>
                </div>

                <el-progress
                  v-if="videoFlag.videoList"
                  type="circle"
                  :percentage="videoUploadPercent.videoList"
                  style="margin-top: 30px"
                ></el-progress>
                <el-upload
                  class="avatar-uploader el-upload--text"
                  :action="uploadImg"
                  list-type="picture-card"
                  :headers="uploadHeader"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) => {
                      return handleVideoSuccess(
                        response,
                        file,
                        fileList,
                        'videoList'
                      )
                    }
                  "
                  :before-upload="
                    (file) => {
                      return beforeUploadVideo(file, 'videoList')
                    }
                  "
                  :on-progress="
                    (event, file, fileList) => {
                      return uploadVideoProcess(
                        event,
                        file,
                        fileList,
                        'videoList'
                      )
                    }
                  "
                  :accept="acceptTips"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="text">
                {{ uploadTips }}
              </div>
            </el-form-item>
            <el-form-item>
              <div class="dialog-title">
                董事长照片<el-tooltip
                  class="item"
                  effect="dark"
                  :content="content"
                  placement="top-start"
                >
                  <i class="el-icon-warning-outline"></i
                ></el-tooltip>
              </div>
              <!-- action必选参数, 上传的地址 -->
              <div class="dialog-imgItem">
                <div
                  v-for="(item, index) in ruleForm.chairmaneList"
                  :key="item.ossUrl"
                  class="dialog-imgView"
                >
                  <div v-if="item.fileType == 3">
                    <video
                      :src="item.ossUrl"
                      class="avatar"
                      controls="controls"
                    >
                      您的浏览器不支持视频播放
                    </video>
                    <i
                      class="del-img el-icon-close"
                      @click="forkImage(index, 'chairmaneList')"
                    ></i>
                  </div>
                  <div v-if="item.fileType == 1">
                    <el-image
                      :src="item.ossUrl"
                      alt=""
                      :preview-src-list="[item.ossUrl]"
                      :z-index="zIndex"
                    />
                    <i
                      class="del-img el-icon-close"
                      @click="newforkImage(index, 'chairmaneList')"
                    ></i>
                  </div>
                </div>
                <el-progress
                  v-if="videoFlag.chairmaneList"
                  type="circle"
                  :percentage="videoUploadPercent.chairmaneList"
                  style="margin-top: 30px"
                ></el-progress>
                <el-upload
                  class="avatar-uploader el-upload--text"
                  :action="uploadImg"
                  list-type="picture-card"
                  :headers="uploadHeader"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) => {
                      return handleVideoSuccess(
                        response,
                        file,
                        fileList,
                        'chairmaneList'
                      )
                    }
                  "
                  :before-upload="
                    (file) => {
                      return beforeUploadVideo(file, 'chairmaneList')
                    }
                  "
                  :on-progress="
                    (event, file, fileList) => {
                      return uploadVideoProcess(
                        event,
                        file,
                        fileList,
                        'chairmaneList'
                      )
                    }
                  "
                  :accept="acceptTips"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="text">
                {{ uploadTips }}
              </div>
            </el-form-item>
            <el-form-item>
              <div class="dialog-title">
                厂房照片<el-tooltip
                  class="item"
                  effect="dark"
                  :content="content"
                  placement="top-start"
                >
                  <i class="el-icon-warning-outline"></i
                ></el-tooltip>
              </div>
              <!-- action必选参数, 上传的地址 -->
              <div class="dialog-imgItem">
                <div
                  v-for="(item, index) in ruleForm.entWorkshopList"
                  :key="item.ossUrl"
                  class="dialog-imgView"
                >
                  <div v-if="item.fileType == 3">
                    <video
                      :src="item.ossUrl"
                      class="avatar"
                      controls="controls"
                    >
                      您的浏览器不支持视频播放
                    </video>
                    <i
                      class="del-img el-icon-close"
                      @click="forkImage(index, 'entWorkshopList')"
                    ></i>
                  </div>
                  <div v-if="item.fileType == 1">
                    <el-image
                      :src="item.ossUrl"
                      alt=""
                      :preview-src-list="[item.ossUrl]"
                      :z-index="zIndex"
                    />
                    <i
                      class="del-img el-icon-close"
                      @click="newforkImage(index, 'entWorkshopList')"
                    ></i>
                  </div>
                </div>
                <el-progress
                  v-if="videoFlag.entWorkshopList"
                  type="circle"
                  :percentage="videoUploadPercent.entWorkshopList"
                  style="margin-top: 30px"
                ></el-progress>
                <el-upload
                  class="avatar-uploader el-upload--text"
                  :action="uploadImg"
                  list-type="picture-card"
                  :headers="uploadHeader"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) => {
                      return handleVideoSuccess(
                        response,
                        file,
                        fileList,
                        'entWorkshopList'
                      )
                    }
                  "
                  :before-upload="
                    (file) => {
                      return beforeUploadVideo(file, 'entWorkshopList')
                    }
                  "
                  :on-progress="
                    (event, file, fileList) => {
                      return uploadVideoProcess(
                        event,
                        file,
                        fileList,
                        'entWorkshopList'
                      )
                    }
                  "
                  :accept="acceptTips"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="text">
                {{ uploadTips }}
              </div>
            </el-form-item>
            <el-form-item>
              <div class="dialog-title">
                产品照片<el-tooltip
                  class="item"
                  effect="dark"
                  :content="content"
                  placement="top-start"
                >
                  <i class="el-icon-warning-outline"></i
                ></el-tooltip>
              </div>
              <div class="dialog-imgItem">
                <div
                  v-for="(item, index) in ruleForm.productList"
                  :key="item.ossUrl"
                  class="dialog-imgView"
                >
                  <div v-if="item.fileType == 3">
                    <video
                      :src="item.ossUrl"
                      class="avatar"
                      controls="controls"
                    >
                      您的浏览器不支持视频播放
                    </video>
                    <i
                      class="del-img el-icon-close"
                      @click="forkImage(index, 'productList')"
                    ></i>
                  </div>
                  <div v-if="item.fileType == 1">
                    <el-image
                      :src="item.ossUrl"
                      alt=""
                      :preview-src-list="[item.ossUrl]"
                      :z-index="zIndex"
                    />
                    <i
                      class="del-img el-icon-close"
                      @click="newforkImage(index, 'productList')"
                    ></i>
                  </div>
                </div>
                <el-progress
                  v-if="videoFlag.productList"
                  type="circle"
                  :percentage="videoUploadPercent.productList"
                  style="margin-top: 30px"
                ></el-progress>
                <el-upload
                  class="avatar-uploader el-upload--text"
                  :action="uploadImg"
                  list-type="picture-card"
                  :headers="uploadHeader"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) => {
                      return handleVideoSuccess(
                        response,
                        file,
                        fileList,
                        'productList'
                      )
                    }
                  "
                  :before-upload="
                    (file) => {
                      return beforeUploadVideo(file, 'productList')
                    }
                  "
                  :on-progress="
                    (event, file, fileList) => {
                      return uploadVideoProcess(
                        event,
                        file,
                        fileList,
                        'productList'
                      )
                    }
                  "
                  :accept="acceptTips"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="text">
                {{ uploadTips }}
              </div>
            </el-form-item>
            <el-form-item>
              <div class="dialog-title">
                企业荣誉<el-tooltip
                  class="item"
                  effect="dark"
                  :content="content"
                  placement="top-start"
                >
                  <i class="el-icon-warning-outline"></i
                ></el-tooltip>
              </div>
              <!-- action必选参数, 上传的地址 -->
              <div class="dialog-imgItem">
                <div
                  v-for="(item, index) in ruleForm.honorFiles"
                  :key="item.ossUrl"
                  class="dialog-imgView"
                >
                  <div v-if="item.fileType == 3">
                    <video
                      :src="item.ossUrl"
                      class="avatar"
                      controls="controls"
                    >
                      您的浏览器不支持视频播放
                    </video>
                    <i
                      class="del-img el-icon-close"
                      @click="forkImage(index, 'honorFiles')"
                    ></i>
                  </div>
                  <div v-if="item.fileType == 1">
                    <el-image
                      :src="item.ossUrl"
                      alt=""
                      :preview-src-list="[item.ossUrl]"
                      :z-index="zIndex"
                    />
                    <i
                      class="del-img el-icon-close"
                      @click="newforkImage(index, 'honorFiles')"
                    ></i>
                  </div>
                </div>
                <el-progress
                  v-if="videoFlag.honorFiles"
                  type="circle"
                  :percentage="videoUploadPercent.honorFiles"
                  style="margin-top: 30px"
                ></el-progress>
                <el-upload
                  class="avatar-uploader el-upload--text"
                  :action="uploadImg"
                  list-type="picture-card"
                  :headers="uploadHeader"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) => {
                      return handleVideoSuccess(
                        response,
                        file,
                        fileList,
                        'honorFiles'
                      )
                    }
                  "
                  :before-upload="
                    (file) => {
                      return beforeUploadVideo(file, 'honorFiles')
                    }
                  "
                  :on-progress="
                    (event, file, fileList) => {
                      return uploadVideoProcess(
                        event,
                        file,
                        fileList,
                        'honorFiles'
                      )
                    }
                  "
                  :accept="acceptTips"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="text">
                {{ uploadTips }}
              </div>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getEntDetail } from '@api/corporateInteraction/enterprise'
import { uploadImg } from '@api/video/liveOperation'
import { insertOrUpdateEntStyle } from '@api/corporateInteraction/enterprise'
import { getToken } from '@utils'
export default {
  name: 'EntStyle',
  data() {
    return {
      content:
        '视频支持mp4，avi，wmv，mov，flv，rmvb，3gp，m4v，mkv格式；图片支持png，jpg，jpeg，tif，bmp。文件最大不超过300M',
      uploadTips: '只支持常见的图片和视频格式，最多不超过10个',
      acceptTips:
        '.mp4, .avi, .mov,.m4v,.mkv,.fiv,.wmv,.rmvb,.3gp,.jpg, .png, .jpeg, .tif, .bmp',
      zIndex: 999999,
      videoFlag: {
        videoList: false,
        chairmaneList: false,
        entWorkshopList: false,
        productList: false,
        honorFiles: false
      },
      uploadImg,
      dialogVisible: false,
      ruleForm: {
        videoList: [],
        honorFiles: [],
        chairmaneList: [],
        entWorkshopList: [],
        productList: []
      },
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      creditCode: '',
      id: '',
      videos: [], // 企业宣传视频
      honorFiles: [],
      chairmanes: [],
      entWorkshops: [],
      products: [],
      videoUploadPercent: {
        videoList: 0,
        chairmaneList: 0,
        entWorkshopList: 0,
        productList: 0,
        honorFiles: 0
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id
    // 政府端从列表传过来 creditCode ，企业端直接从存储里获取
    this.creditCode =
      this.$route.query.creditCode || this.$store.state.user.userInfo.nickName
    this.getEntDetail()
  },
  methods: {
    // 获取企业详情信息
    getEntDetail() {
      getEntDetail({ creditCode: this.creditCode }).then((res) => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.videos = data.videos
          this.honorFiles = data.honorFiles
          this.chairmanes = data.chairmanes
          this.entWorkshops = data.entWorkshops
          this.products = data.products
          // 企业端-企业信息，没有列表信息，直接从企业详情中获取
          if (!this.id) {
            this.id = data.entData.id
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    edit() {
      this.dialogVisible = true
      this.ruleForm.videoList = [...this.videos] || []
      this.ruleForm.chairmaneList = [...this.chairmanes] || []
      this.ruleForm.entWorkshopList = [...this.entWorkshops] || []
      this.ruleForm.productList = [...this.products] || []
      this.ruleForm.honorFiles = [...this.honorFiles] || []
    },
    handleClose() {
      this.dialogVisible = false
    },
    uploadVideoProcess(event, file, fileList, list) {
      this.videoFlag[list] = true
      this.videoUploadPercent[list] = Number(file.percentage.toFixed(0))
    },
    handleVideoSuccess(res, file, fileList, List) {
      // 获取上传图片地址
      this.videoFlag[List] = false
      this.videoUploadPercent[List] = 0
      if (res.code == '0000') {
        if (
          [
            'png',
            'jpg',
            'jpeg',
            'JPG',
            'PNG',
            'JPEG',
            'tif',
            'bmp',
            'TIF',
            'BMP'
          ].indexOf(res.data.ext) !== -1
        ) {
          this.ruleForm[List].push({
            fileType: 1,
            fileName: res.data.fileName,
            ossUrl: res.data.ossUrl
          })
        } else {
          this.ruleForm[List].push({
            fileType: 3,
            fileName: res.data.fileName,
            ossUrl: res.data.ossUrl
          })
        }
      } else {
        this.$message.error('视频上传失败，请重新上传！')
      }
    },
    // 删除视频
    forkImage(index, List) {
      this.ruleForm[List].splice(index, 1)
    },
    // 删除图片
    newforkImage(index, List) {
      this.ruleForm[List].splice(index, 1)
    },
    beforeUploadVideo(file, List) {
      const isLt10M = file.size / 1024 / 1024 < 300
      if (
        [
          'video/mp4',
          'video/mov',
          'video/quicktime',
          'video/m4v',
          'video/mkv',
          'video/x-matroska',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/x-ms-wmv',
          'video/3gpp',
          'image/png',
          'image/jpg',
          'image/jpeg',
          'image/tif',
          'image/bmp'
        ].indexOf(file.type) == -1
      ) {
        this.$message.error('请上传正确的视频格式或者图片格式')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传视频大小不能超过300MB哦!')
        return false
      }
      const num = this.ruleForm[List].length
      if (num >= 10) {
        this.$message.error('当前上传文件已达到数量限制')
        return false
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            id: this.id,
            creditCode: this.creditCode
          }
          insertOrUpdateEntStyle(data).then((res) => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              this.dialogVisible = false
              this.getEntDetail()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .el-dialog__body {
    padding: 30px 60px 20px;
    font-size: 16px;
    height: 650px !important;
    overflow: auto;
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.entStyle {
  .left-title {
    font-size: 16px;
    margin-left: 8px;
    position: relative;
    color: rgba(0, 0, 0, 0.8);
    &::before {
      content: '';
      position: absolute;
      left: -8px;
      vertical-align: middle;
      width: 3px;
      height: 16px;
      display: inline-block;
      margin-right: 0.1rem;
      background: #3399ff;
    }
  }
  .imgList {
    display: flex;
    flex-wrap: wrap;
    .imgOrVideo {
      margin: 10px 20px 10px 0;
      .el-image {
        width: 148px;
        height: 148px;
      }
    }
    .avatar {
      width: 148px;
      height: 148px;
      object-fit: cover; // 自定义宽高
    }
  }
  .dialog-title {
    font-size: 16px;
    color: #000;
  }
  .del-img {
    font-size: 20px;
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    z-index: 999;
  }
  .edit-btn {
    display: flex;
    justify-content: flex-end;
  }
  .avatar {
    width: 148px;
    height: 148px;
    object-fit: cover; // 自定义宽高
  }
  .noData {
    width: 200px;
    height: 200px;
    img {
      cursor: pointer;
      width: 150px;
      height: 150px;
      margin-right: 15px;
    }
  }
  .dialog-imgItem {
    display: flex;
    flex-wrap: wrap;
    .dialog-imgView {
      margin-right: 10px;
      position: relative;
      .el-image {
        width: 148px;
        height: 148px;
      }
    }
  }
}
</style>

